import {
  Avatar,
  Box,
  Drawer,
  Grid,
  IconButton,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import { useState, useEffect } from "react";
import { tokens } from "../../theme";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CloseIcon from "@mui/icons-material/Close";
import TodayIcon from '@mui/icons-material/Today';
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { Link, useLocation, useParams } from "react-router-dom";
import UserSessionModal from "../../components/Global/UserSessionModal/UserSessionModal";

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const location = useLocation();
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const { day } = useParams();
  const [currentUser, setCurrentUser] = useState("");
  const [showUserModal, setShowUserModal] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem("currentUser");
    if (storedUser) {
      setCurrentUser(storedUser);
    }
  }, []);

  const handleUserSelection = (userName) => {
    setCurrentUser(userName);
    setShowUserModal(false);
  };

  const getUserImage = () => {
    if (currentUser === "David Acevedo") return "/david.jpg";
    if (currentUser === "Vannesa Santamaria") return "/vannesa.jpg";
    return "";
  };

  const getItemStyles = (path) => ({
    boxShadow:
      location.pathname === path
        ? "rgba(0, 0, 0, 0.24) 0px 3px 8px"
        : `${colors.grey[600]} 0px 3px 8px`,
    bgcolor:
      location.pathname === path ? colors.primary[900] : colors.grey[600],
    borderRadius: "10px",
    marginBottom: "12px",
    color: "#ffffff",
  });

  console.log("path", location.pathname);

  // Traducción de días de la semana
  const dayTranslations = {
    day1: "Día 1",
    day2: "Día 2",
    day3: "Día 3",
    day4: "Día 4",
    day5: "Día 5",
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        ml: { xs: "0px", md: "30px" },
        padding: { xs: 2, md: 3 },
        flexDirection: { xs: "column", md: "row" },
        backgroundColor: {xs:colors.grey[900], md:"transparent"}
      }}
    >
      <Grid container spacing={1} alignItems="center" justifyContent="flex-end">
        <Grid
          item
          xs={10}
          md={12}
          sx={{
            display: { xs: "flex" },
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <Typography variant="h4">
            Rutina:{" "}
            <strong>{dayTranslations[day] || day || "Sin día"}</strong>
          </Typography>
        </Grid>
        <Grid
          item
          xs={2}
          sx={{
            display: { xs: "flex", md: "none" },
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <IconButton onClick={() => setDrawerOpen(true)}>
            <MenuOutlinedIcon />
          </IconButton>
        </Grid>
      </Grid>

      {/* Menú Lateral */}
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          style: {
            backgroundColor: colors.grey[900],
            width: "100%",
          },
        }}
      >
        <Box
          style={{
            margin: "10px",
            color: colors.primary[500],
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "10px"
          }}
        >
          <IconButton
            onClick={() => setDrawerOpen(false)}
            style={{ margin: "15px" }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            justifyContent: "space-between",
            padding: "0 15px 0 15px",
          }}
        >
          <Box>
            {currentUser && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "16px 20px",
                  mb: 3,
                  border: `2px solid ${colors.primary[900]}`,
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 16px rgba(0,0,0,0.4)",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Avatar
                    src={getUserImage()}
                    alt={currentUser}
                    sx={{ 
                      width: 50, 
                      height: 50,
                      border: `3px solid ${colors.primary[900]}`,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                    }}
                  />
                  <Box>
                    <Typography 
                      variant="caption" 
                      sx={{ 
                        color: colors.grey[400],
                        fontSize: "0.6rem",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px"
                      }}
                    >
                      Usuario Activo
                    </Typography>
                    <Typography 
                      variant="body1" 
                      fontWeight="bold"
                      sx={{ 
                        fontSize: "0.8rem",
                        color: "#ffffff",
                        lineHeight: 1.2
                      }}
                    >
                      {currentUser}
                    </Typography>
                  </Box>
                </Box>
                <IconButton
                  onClick={() => setShowUserModal(true)}
                  sx={{
                    color: colors.primary[300],
                    bgcolor: colors.grey[800],
                    padding: "8px",
                    "&:hover": {
                      bgcolor: colors.primary[700],
                      color: "#ffffff",
                      transform: "rotate(180deg)",
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  <SwapHorizIcon />
                </IconButton>
              </Box>
            )}
            <ListItem component={Link} to={`/`} sx={getItemStyles(`/dashboard`)} onClick={() => setDrawerOpen(false)}>
              <SpaceDashboardIcon sx={{ mr: 2, color: "#ffffff" }} />
              <ListItemText primary="Inicio" sx={{ color: "#ffffff" }} />
            </ListItem>
            <ListItem component={Link} to={`/routines/day1`} sx={getItemStyles(`/routines/day1`)} onClick={() => setDrawerOpen(false)}>
              <TodayIcon sx={{ mr: 2, color: "#ffffff" }} />
              <ListItemText primary="Día 1" sx={{ color: "#ffffff" }} />
            </ListItem>
            <ListItem component={Link} to={`/routines/day2`} sx={getItemStyles(`/routines/day2`)} onClick={() => setDrawerOpen(false)}>
              <TodayIcon sx={{ mr: 2, color: "#ffffff" }} />
              <ListItemText primary="Día 2" sx={{ color: "#ffffff" }} />
            </ListItem>
            <ListItem component={Link} to={`/routines/day3`} sx={getItemStyles(`/routines/day3`)} onClick={() => setDrawerOpen(false)}>
              <TodayIcon sx={{ mr: 2, color: "#ffffff" }} />
              <ListItemText primary="Día 3" sx={{ color: "#ffffff" }} />
            </ListItem>
            <ListItem component={Link} to={`/routines/day4`} sx={getItemStyles(`/routines/day4`)} onClick={() => setDrawerOpen(false)}>
              <TodayIcon sx={{ mr: 2, color: "#ffffff" }} />
              <ListItemText primary="Día 4" sx={{ color: "#ffffff" }} />
            </ListItem>
            <ListItem component={Link} to={`/routines/day5`} sx={getItemStyles(`/routines/day5`)} onClick={() => setDrawerOpen(false)}>
              <TodayIcon sx={{ mr: 2, color: "#ffffff" }} />
              <ListItemText primary="Día 5" sx={{ color: "#ffffff" }} />
            </ListItem>
          </Box>
        </Box>
      </Drawer>
      <UserSessionModal open={showUserModal} onSelectUser={handleUserSelection} />
    </Box>
  );
};

export default Topbar;
